import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { assetIdValidator } from "../assets/TLBaseAsset";
/** @internal */ export const documentValidator = T.model("document", T.object({
    typeName: T.literal("document"),
    id: T.literal("document:document"),
    gridSize: T.number,
    name: T.string,
    fontFamily: T.union("type", {
        google: T.object({
            type: T.literal("google"),
            name: T.string
        }),
        custom: T.object({
            type: T.literal("custom"),
            assetId: assetIdValidator
        })
    }).optional(),
    meta: T.jsonValue
}));
/** @internal */ export const documentVersions = {
    AddName: 1,
    AddMeta: 2
};
/** @internal */ export const documentMigrations = defineMigrations({
    currentVersion: documentVersions.AddMeta,
    migrators: {
        [documentVersions.AddName]: {
            up: (document)=>{
                return {
                    ...document,
                    name: ""
                };
            },
            down: ({ name: _, ...document })=>{
                return document;
            }
        },
        [documentVersions.AddMeta]: {
            up: (record)=>{
                return {
                    ...record,
                    meta: {}
                };
            },
            down: ({ meta: _, ...record })=>{
                return {
                    ...record
                };
            }
        }
    }
});
/** @public */ export const DocumentRecordType = createRecordType("document", {
    migrations: documentMigrations,
    validator: documentValidator,
    scope: "document"
}).withDefaultProperties(()=>({
        gridSize: 10,
        name: "",
        meta: {}
    }));
// all document records have the same ID: 'document:document'
/** @public */ export const SWDOCUMENT_ID = DocumentRecordType.createId("document");
